import { Checkbox as MantineCheckbox } from '@mantine/core';
import type { CheckboxProps as MantineCheckboxProps, CheckboxIconProps } from '@mantine/core';
import './Checkbox.css';

export interface CheckboxProps extends MantineCheckboxProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function CheckboxCheckIcon({ indeterminate, ...others }: CheckboxIconProps) {
  if (indeterminate) {
    return (
      <svg viewBox="0 0 10 10" fill="none" aria-hidden {...others}>
        <path d="M2 5h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 10 10" fill="none" aria-hidden {...others}>
      <path
        d="M2.1 5.2 4.2 7.3 7.9 2.8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Checkbox({
  className = '',
  icon = CheckboxCheckIcon,
  ...props
}: CheckboxProps) {
  const checkboxClass = `checkbox ${className}`.trim();

  return <MantineCheckbox className={checkboxClass} icon={icon} {...props} />;
}
